// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1IY2Y","paramInput":"JobSimulator_paramInput__dcSlG","input":"JobSimulator_input__2iBDm"};